module.exports = __webpack_public_path__ + "static/media/480.8d94297b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-insect/light/480.png
// module id = 2188
// module chunks = 2